import { useState } from 'react';
import { isMobile } from 'react-device-detect';
interface ResponsiveTooltip {
  onTouchStart: () => void;
  onClickAway: (event: TouchEvent | MouseEvent) => void;
  isTooltipOpen: boolean | undefined;
}

// For mouse devices: hover/unhover.
// For touch devices: tap / tap outside
// For mouse devices we keep tooltip uncontrolled (open is undefined, default events are used)
// For touch devices we use controlled tooltip (open is boolean, custom events are used)
export const useResponsiveTooltip = (): ResponsiveTooltip => {
  const [open, setOpen] = useState<boolean | undefined>(isMobile ? false : undefined);

  return {
    onTouchStart: (): void => {
      if (isMobile) setOpen(true);
    },
    onClickAway: (event): void => {
      if ((event.target as HTMLElement).closest('a')) {
        return;
      }

      if (isMobile) setOpen(false);
    },
    isTooltipOpen: open
  };
};
